/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "pay": {
            "nested": {
              "ManagedCustomerRequestFlowData": {
                "fields": {
                  "source": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "payload": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "payloadMap": {
                    "type": "string",
                    "id": 3,
                    "keyType": "string"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.pay?.nested?.ManagedCustomerRequestFlowData) {
  $root.addJSON(jsonData);
}

/**
 * Initiation data for the Managed Customer Request Plasma Flow.
 *
 * Client provides this object to the server to identify the third-party caller and relay a
 * third-party payload.
 *
 * SOURCE ManagedCustomerRequestFlowData @ squareup/cash/pay/managed_customer_request.proto at 13:1
 */
export const ManagedCustomerRequestFlowData = $root.lookupType('squareup.cash.pay.ManagedCustomerRequestFlowData');
fixType(ManagedCustomerRequestFlowData);
Builder.createAndAttachToType(ManagedCustomerRequestFlowData);